export enum TipoCodigoParametroImpositivo {
    IVA = 0, 
    PERIVA = 1, 
    IIBB = 2, 
    PERIIBB = 3, 
    CO2 = 4, 
    IMPINT = 5, 
    // OTRO = 6, 
    PERMUN = 7
}